const defaultBoxes = '';
const totalBoxes = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'BOX_COUNT_SUCCESS':
      return action.boxes;
    default:
      return state;
  }
};

export default totalBoxes;
